import { render, staticRenderFns } from "./ModalProductDetail.vue?vue&type=template&id=d8eaf000&"
import script from "./ModalProductDetail.vue?vue&type=script&lang=js&"
export * from "./ModalProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports